import api from './api'

export default {
    fetchEdytowanie(params) {
      console.log(params)
      return api.get(`edytowanie/`, params)
                .then(response => response.data)
    },
    postEdytowanie(payload) {
      return api.post(`edytowanie/`, payload)
              },
    deleteEdytowanie(params) {
      return api.get(`edytowanie/delete/`, params)
              },
    deleteAllEdytowania(){
        return api.get(`edytowanie/delete_all/`)
    }
            }

    